import { Facebook, Instagram, Linkedin, Youtube, Twitter } from "lucide-react";

// WhatsApp + X(twitter) — using lucide where available, otherwise inline svg
export const PlatformIcon = ({ platform, className = "h-4 w-4" }) => {
  switch (platform) {
    case "facebook":
      return <Facebook className={className} />;
    case "instagram":
      return <Instagram className={className} />;
    case "linkedin":
      return <Linkedin className={className} />;
    case "youtube":
      return <Youtube className={className} />;
    case "x":
      return (
        <svg viewBox="0 0 24 24" className={className} fill="currentColor">
          <path d="M18.244 2H21l-6.52 7.45L22 22h-6.84l-4.79-6.27L4.8 22H2l7-8L1.5 2h6.9l4.36 5.78L18.244 2zM17.1 20h1.61L7 4H5.27L17.1 20z" />
        </svg>
      );
    case "twitter":
      return <Twitter className={className} />;
    case "whatsapp":
      return (
        <svg viewBox="0 0 24 24" className={className} fill="currentColor">
          <path d="M20.52 3.48A11.94 11.94 0 0012.05 0C5.5 0 .14 5.36.14 11.92c0 2.1.55 4.15 1.6 5.96L0 24l6.27-1.65a11.9 11.9 0 005.77 1.47h.01c6.55 0 11.9-5.36 11.9-11.91 0-3.18-1.24-6.18-3.43-8.43zM12.05 21.8h-.01a9.86 9.86 0 01-5.02-1.38l-.36-.21-3.72.98.99-3.63-.23-.37a9.85 9.85 0 01-1.5-5.27c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.13 1.03 7 2.9a9.84 9.84 0 012.9 7c-.01 5.45-4.45 9.86-9.95 9.86zm5.43-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01a1.1 1.1 0 00-.8.37c-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.5 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35z" />
        </svg>
      );
    default:
      return null;
  }
};

export const platformColor = (p) => {
  switch (p) {
    case "facebook":
      return "#1877F2";
    case "instagram":
      return "#E1306C";
    case "whatsapp":
      return "#25D366";
    case "linkedin":
      return "#0A66C2";
    case "x":
      return "#0A1730";
    case "youtube":
      return "#FF0000";
    default:
      return "#0A1730";
  }
};
